<div
    class="payment-option"
    [ngClass]="{'payment-option--extended': showForm && isSelected, 'payment-option--unselected': !isSelected}"
    (click)="handlePaymentOptionClick()"
>
    <div class="info-section">
        <div class="payment-option__left">
            <div class="payment-option__circle">
                <div class="circle__outer" [class.circle__outer--selected]="isSelected">
                    <div class="circle__inner" [class.circle__inner--selected]="isSelected"></div>
                </div>
            </div>
            <div class="payment-option__label"
                [class.payment-option__label--new]="showForm"
                [class.payment-option__label--new-selected]="showForm && isSelected"
            >{{ formattedLabel }}</div>
        </div>
        <div class="payment-option__image-container">
            <img [src]="imageSource" alt="card" width="48" height="34" />
        </div>
    </div>
    <div class="form-section" *ngIf="showForm" [@slideFade]="(showForm && isSelected) ? 'in' : 'out'">
        <form [formGroup]="formGroup">
            <div class="form-controls form-controls--credit" *ngIf="isCreditType">
                <sc-select
                    class="form-controls__type"
                    formControlName="creditCardType"
                    label="Tarjeta"
                    placeholder="Seleccioná una tarjeta"
                    objectValue="name"
                    [items]="creditCardTypeOptions"
                    [hideError]="true"
                    (optionSelected)="handleCreditCardTypeChange($event)"
                ></sc-select>
                <div class="form-controls__number">
                    <label for="creditCardNumber__field">Nro tarjeta</label>
                    <input
                        id="creditCardNumber__field"
                        type="text"
                        maxlength="16"
                        formControlName="creditCardNumber"
                        placeholder="0000 0000 0000 0000"
                        [readonly]="!formGroup.value.creditCardType ? true : null"
                        (input)="onlyNumbers($event)">
                    <sc-icon [icon]="setNumberFieldIcon(formGroup.get('creditCardNumber'))" class="form-controls__input-icon"></sc-icon>
                </div>
            </div >
            <div class="form-controls" *ngIf="!isCreditType">
                <div class="form-controls__number">
                    <label for="cbuNumber__field">Nro CBU</label>
                    <input
                        id="cbuNumber__field"
                        type="text"
                        maxlength="22"
                        formControlName="cbuNumber"
                        placeholder="00000000000000000000000"
                        (input)="onlyNumbers($event)">
                    <sc-icon [icon]="setNumberFieldIcon(formGroup.get('cbuNumber'))" class="form-controls__input-icon"></sc-icon>
                </div>
            </div>
        </form>
    </div>
</div>
